import { useStore } from '@spazious/dollhouse-store';

/**
 * Access the commander instance from the store
 */
export const useCommander = () => {
  const store = useStore();
  return store.commander;
};
